import { createContext } from "react";
var SubmissionContext = createContext({});
export default SubmissionContext;
//# sourceMappingURL=submission-context.js.map